import styled from 'styled-components';
import { Button } from '@/components/UI/Button/Button';
import { Typography } from '@/components/UI/Typography/Typography.styles';

export const Container = styled.div`
  display: grid;
  gap: 20px;
  background-color: ${({ theme }) => theme.palette.secondary.background};

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    gap: 5px;
  }
`;

export const ProfileCard = styled.section`
  display: grid;
  gap: 20px;
  padding: 30px;
  border-radius: 21px;
  background-color: ${({ theme }) => theme.palette.primary.background};

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: 20px 15px;
    border-radius: 14px;
  }
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    display: contents;
  }
`;

export const MainTitle = styled(Typography.Header)`
  font-size: 24px;
  font-weight: 700;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    display: none;
  }
`;

export const Title = styled(Typography.Header)`
  font-weight: 500;
`;

export const EditLink = styled(Button).attrs({
  appearance: 'secondaryLight',
  height: 40,
})`
  font-size: 14px;
  border-radius: 10px;
  padding: 0 20px;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    order: 2;
    width: 100%;
    margin-top: 15px;
  }

  @media (hover: hover) {
    &:hover {
      background-color: #c1d9ff;
    }
  }
`;

export const Fields = styled.div`
  display: grid;
  gap: 20px;
  width: min(100%, 400px);

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    gap: 15px;
    width: 100%;
  }
`;

export const FieldWithIcon = styled.div`
  position: relative;
`;

export const FieldIcon = styled.span`
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
`;

export const EmailWarning = styled.div`
  display: grid;
  gap: 12px;
  padding: 15px;
  border-radius: 14px;
  background-color: ${({ theme }) => theme.palette.system.lightYellow};
`;

export const EmailWarningText = styled(Typography.Caption)`
  color: ${({ theme }) => theme.palette.primary.labels};
`;

export const EmailWarningButton = styled.button`
  width: fit-content;
  padding: 0;
  border: 0;
  background: none;
  color: ${({ theme }) => theme.palette.system.blue};
  font: inherit;
  font-size: 13px;
  cursor: pointer;

  @media (hover: hover) {
    &:hover {
      color: ${({ theme }) => theme.palette.system.deepBlue};
    }
  }
`;

export const InfoCard = styled.section`
  display: grid;
  gap: 20px;
  padding: 30px;
  border-radius: 21px;
  background-color: ${({ theme }) => theme.palette.primary.background};

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: 20px 15px;
    border-radius: 14px;
  }
`;

export const InfoRows = styled.div`
  display: grid;
  gap: 18px;
`;

export const InfoRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
`;

export const InfoLabel = styled(Typography.Body).attrs({ $variant: '1' })`
  color: ${({ theme }) => theme.palette.secondary.labels};
`;

export const InfoValue = styled(Typography.Body).attrs({ $variant: '1' })`
  color: ${({ theme }) => theme.palette.primary.labels};
  text-align: right;
`;

export const RemoveCard = styled.section`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  padding: 30px;
  border-radius: 21px;
  background-color: ${({ theme }) => theme.palette.primary.background};

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    flex-direction: column;
    align-items: flex-start;
    padding: 20px 15px;
    border-radius: 14px;
  }
`;

export const RemoveContent = styled.div`
  display: grid;
  gap: 15px;
`;

export const RemoveDescription = styled(Typography.Body).attrs({
  $variant: '1',
})`
  color: ${({ theme }) => theme.palette.secondary.labels};
`;

export const RemoveButton = styled.button`
  padding: 0;
  border: 0;
  background: none;
  color: ${({ theme }) => theme.palette.secondary.labels};
  font-size: 15px;
  text-decoration: underline;
  cursor: pointer;

  @media (hover: hover) {
    &:hover {
      color: ${({ theme }) => theme.palette.system.red};
    }
  }
`;

export const EmailInputContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;
